<template>
  <div class="order-page">
  <div class="row">&nbsp;</div>
  <div class="container-fluid">
    <div class="row">
      <div class="col" v-if="this.is_event_permission === 'Y'">
        <div class="row">
          <!-- <WelcomeCard /> -->
          <div class="col-xxl-12">
            <div class="row widget-grid">
              <!-- <OrderWelcomeCard /> -->
              <div class="col-xxl-4 col-sm-12 box-col-12">
                <div class="card profile-box section-card summary-hero-card">
                  <div class="card-body">
                    <div class="media">
                      <div class="media-body">
                        <div class="greeting-user">
                          <h4 class="f-w-600 mb-0">{{ t("orderSummary") }}</h4>
                          <p>{{ this.eventDetails.title }}</p>
                          <!-- <p>{{ this.eventDetails.event_date }},{{ this.eventDetails.province }}</p> -->

                          <p>&nbsp;</p>
                          <p>&nbsp;</p>
                        </div>
                      </div>
                    </div>
                    <div class="cartoon">
                      <img
                        class="img-fluid"
                        src="@/assets/images/dashboard/cartoon.svg"
                        alt="vector women with leptop"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- <OrderPurchaseSaleCard /> -->
              <div class="col-xl-4 col-sm-6 box-col-6">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="card widget-1 section-card summary-stat-card">
                      <div class="card-body">
                        <div class="widget-content">
                          <div class="widget-round secondary">
                            <div class="bg-round">
                              <svg class="svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#cart`
                                  "
                                ></use>
                              </svg>
                              <svg class="half-circle svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#halfcircle`
                                  "
                                ></use>
                              </svg>
                            </div>
                          </div>
                          <div>
                            <h4>{{ formatCount(this.total_order) }}</h4>
                            <span class="f-light"> {{ t("orders") }} </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card widget-1 section-card summary-stat-card">
                      <div class="card-body">
                        <div class="widget-content">
                          <div class="widget-round primary">
                            <div class="bg-round">
                              <svg class="svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#income`
                                  "
                                ></use>
                              </svg>
                              <svg class="half-circle svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#halfcircle`
                                  "
                                ></use>
                              </svg>
                            </div>
                          </div>
                          <div>
                            <h4>{{ formatCount(this.total_image) }}</h4>
                            <span class="f-light"> {{ t("imagesSold") }} </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-sm-6 box-col-6">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="card widget-1 section-card summary-stat-card">
                      <div class="card-body">
                        <div class="widget-content">
                          <div class="widget-round success">
                            <div class="bg-round">
                              <svg class="svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#tag`
                                  "
                                ></use>
                              </svg>
                              <svg class="half-circle svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#halfcircle`
                                  "
                                ></use>
                              </svg>
                            </div>
                          </div>
                          <div>
                            <h4>{{ formatAmount(this.total_amt_vat) }}</h4>
                            <span class="f-light">
                              {{ t("totalEarnings") }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card widget-1 section-card summary-stat-card">
                      <div class="card-body">
                        <div class="widget-content">
                          <div class="widget-round success">
                            <div class="bg-round">
                              <svg class="svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#customers`
                                  "
                                ></use>
                              </svg>
                              <svg class="half-circle svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#halfcircle`
                                  "
                                ></use>
                              </svg>
                            </div>
                          </div>
                          <div>
                            <h4>{{ formatAmount(this.p_share_vat) }}</h4>
                            <span class="f-light">
                              {{ t("teamShare") }}({{ this.photographer_share }}%,{{
                                this.number_of_photographer
                              }} {{ t("members") }}, ≈{{
                                formatAmount(
                                  this.number_of_photographer
                                    ? this.p_share_vat / this.number_of_photographer
                                    : 0
                                )
                              }})
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <AllCampaignsCard /> -->

      <div v-if="this.is_event_permission === 'Y'">
        <div class="col-xl-12">
          <div class="card section-card">
            <div class="card-header">
              <div class="header-top action-header">
                <h5 class="m-0">{{ t("ordersTitle") }}</h5>
                <div class="d-flex gap-2">
                  <button v-if="parseInt(this.user.user_id) === admin_user_id_apisitchu" type="button"
                    @click.prevent="exportExcelReport()"
                    class="btn btn-success"
                    :disabled="is_exporting_excel"
                  >
                    <vue-feather type="download" size="18"> </vue-feather>
                    {{ is_exporting_excel ? 'Exporting...' : 'Export Excel Report' }}
                  </button>
                  <button
                    type="button"
                    @click.prevent="loadOrderSummery()"
                    class="btn btn-primary"
                  >
                    <vue-feather type="refresh-cw" size="18"> </vue-feather>
                    Refresh
                  </button>
                </div>
              </div>
              <div class="note-text" v-if="this.is_mhao === 'Y'">
                <ul class="note-list">
                  <li v-html="t('specialConditionOrderNote')"></li>
                </ul>
              </div>
            </div>
            <div class="table-responsive" v-if="this.is_mhao === 'Y'">
              <table class="table table-striped data-table">
                <thead>
                  <tr>
                    <th scope="col" style="text-align: center">{{ t("order") }}</th>
                    <th style="text-align: center">{{ t("quantity") }}<span v-if="this.eventDetails.is_enable_vdo==='Y'">, {{ t("video") }}</span></th>
                    <th style="text-align: center">{{ t("amount") }}</th>
                    <!-- <th style="text-align: center">Image</th> -->
                    <th style="text-align: center">{{ this.is_free_download_keep_contract==='Y'?t("createDate"):t("payment") }}</th>
                    <th style="text-align: center">{{ t("remark") }}</th>
                  </tr>
                </thead>
                <tbody v-if="this.loadding === 'N'">
                  <tr v-for="order in this.orders" :key="order">
                    <td style="text-align: left">
                      <b
                        ><u>
                          <a
                            :href="
                              this.$route.params.q +
                              '/view/' +
                              order.confirm_key +
                              order.id
                            "
                            target="_blank"
                            >{{ order.confirm_key }}{{ order.id }}</a
                          >
                        </u></b
                      >
                    </td>
                    <td style="text-align: center">
                      {{ order.image_length }}<span v-if="this.eventDetails.is_enable_vdo==='Y'">, {{ order.video_length }}</span>
                    </td>
                    <td style="text-align: center">
                      {{ formatAmount(order.amount) }}
                    </td>

                    <td style="text-align: center">
                      {{ order.payment_date }}
                    </td>
                    <td style="text-align: left">
                      {{ 
                        this.is_free_download_keep_contract==='Y'?
                        t("free"):
                        order.amount === 0
                          ? t("specialConditionTag")
                          : order.is_mhao === "Y"
                          ? t("packageUnlimited")
                          : order.amount === this.mhao_price &&
                            order.is_mhao === "N"
                          ? t("packageOverLimit")
                          : "-"
                      }}

                     <!-- {{
                        order.coupon_code
                          ? ", COUPON: " + order.coupon_code.slice(0, 5) + "XXX"
                          : ""
                      }} -->
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.loadding === 'Y'">
                  <tr>
                    <td colspan="5">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 60px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>&nbsp;</p>
              <div class="d-flex justify-content-center">
                <paginate
                  v-if="this.total_order > this.init_page_size"
                  v-model="page"
                  :page-count="this.page_tab"
                  :page-range="3"
                  :margin-pages="2"
                  :clickHandler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginate>
              </div>
            </div>

            <p>&nbsp;</p>

            <div
              class="col-xl-12"
              v-if="this.is_photographer_view_report === 'Y'"
            >
              <div class="card section-card">
                <div class="card-header">
                  <div class="header-top action-header">
                    <h5 class="m-0"><b>{{ t("photographerSummary") }}</b></h5>
                    <button
                      type="button"
                      @click.prevent="loadOrderImageByUser()"
                      class="btn btn-primary action-btn"
                    >
                      <vue-feather type="refresh-cw" size="18"> </vue-feather>
                      Refresh
                    </button>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-striped data-table">
                    <thead>
                      <tr>
                        <th style="text-align: center"><b>{{ t("no") }}</b></th>
                        <th style="text-align: center"><b>{{ t("photographerId") }}</b></th>
                        <th style="text-align: left"><b>{{ t("name") }}</b></th>
                        <th style="text-align: center">
                          <b>{{ t("uploadCount") }}</b>
                        </th>
                        <th style="text-align: center"><b>{{ t("salesCount") }}</b></th>
                        <th style="text-align: center">
                          <b>{{ t("salesCountPercent") }}</b>
                        </th>
                      </tr>
                    </thead>
                    <tbody v-if="this.loadding_order_image_by_user === 'Y'">
                      <tr>
                        <td colspan="6">
                          <div class="d-flex justify-content-center">
                            <img
                              style="align-items: center; width: 60px"
                              src="../../assets/images/running_loading.svg"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody
                      v-if="
                        this.data_order_image_by_user.length === 0 &&
                        this.loadding_order_image_by_user === 'N'
                      "
                    >
                      <tr>
                        <td colspan="6">
                          <div class="d-flex justify-content-center">
                            {{ t("noDataFound") }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="this.data_order_image_by_user.length !== 0">
                      <tr
                        v-for="(item, index) in this.data_order_image_by_user"
                        :key="item"
                      >
                        <td scope="row" style="text-align: center">
                          {{ index + 1 }}
                        </td>
                        <td scope="row" style="text-align: center">
                          {{ item.user_id_text }}
                        </td>
                        <td style="text-align: left">
                          {{ item.display_name }}
                        </td>
                        <td style="text-align: center">
                          {{ item.image_upload_count }}
                        </td>
                        <td style="text-align: center">
                          {{ item.image_sale_count }}
                        </td>
                        <td style="text-align: center">
                          {{ Number(item.percen).toFixed(2) }}%
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- <div class="col-xl-12"  v-if="this.is_photographer_view_report === 'Y'" >
              <div class="card">
                <div class="card-header">
                  <div class="header-top">
                    <h5 class="m-0"><b>Photographer Performance Summary</b></h5>
                    <br />

                    <button
                      v-if="this.is_photographer_view_report === 'Y'"
                      type="button"
                      @click.prevent="reportPerformance()"
                      class="btn btn-primary"
                    >
                      <vue-feather type="refresh-cw" size="18"> </vue-feather>
                      Refresh
                    </button>
                  </div>
                  <p style="text-align: left; font-size: xx-small">
                    <ui>
                      <li>Photos sold in Package Order count as 1 point</li>
                      <li>Photos sold in Individual Order count as 1 point each</li>
                    </ui>
                  </p>
                </div>
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th style="text-align: center"><b>No.</b></th>
                        <th style="text-align: center"><b>Photographer ID</b></th>
                        <th style="text-align: left"><b>Photographer</b></th>
                        <th style="text-align: center"><b>Individual Orders</b></th>
                        <th style="text-align: center"><b>Package Orders</b></th>
                        <th style="text-align: center"><b>Total Score</b></th>
                      </tr>
                    </thead>
                    <tbody v-if="this.loadding_report_performance === 'Y'">
                      <tr>
                        <td colspan="6">
                          <div class="d-flex justify-content-center">
                            <img
                              style="align-items: center; width: 60px"
                              src="../../assets/images/running_loading.svg"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody
                      v-if="
                        this.data_report_performance.length === 0 &&
                        this.loadding_report_performance === 'N'
                      "
                    >
                      <tr>
                        <td colspan="6">
                          <div class="d-flex justify-content-center">
                            No data found
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="this.data_report_performance.length !== 0">
                      <tr
                        v-for="(item, index) in this.data_report_performance"
                        :key="item"
                      >
                        <td scope="row" style="text-align: center">
                          {{ index + 1 }}
                        </td>
                        <td scope="row" style="text-align: center">
                          {{ item.user_id_text }}
                        </td>
                        <td style="text-align: left">
                          {{ item.display_name }}
                        </td>
                        <td style="text-align: center">
                          {{ item.score - item.mhao_score }}
                        </td>
                        <td style="text-align: center">
                          {{ item.mhao_score }}
                        </td>
                        <td style="text-align: center">
                          {{ item.score }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> -->

            <div
              class="col-xl-12"
              v-if="this.is_photographer_view_report === 'Y'"
            >
              <div class="card section-card">
                <div class="card-header">
                  <div class="header-top action-header">
                    <h5 class="m-0">
                      <b>{{ t("orderSalesSummaryByImages") }}</b>
                    </h5>
                    <br />

                    <button
                      type="button"
                      @click.prevent="reportOrderSummery()"
                      class="btn btn-primary action-btn"
                    >
                      <vue-feather type="refresh-cw" size="18"> </vue-feather>
                      Refresh
                    </button>
                  </div>
                  <div class="note-text">
                    <ul class="note-list">
                      <li>{{ t("salesByImageCount") }}</li>
                      <li v-if="this.is_mhao === 'Y'" v-html="t('specialConditionReportNote')"></li>
                    </ul>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-striped data-table">
                    <thead>
                      <tr>
                        <th style="text-align: center"><b>{{ t("no") }}</b></th>
                        <th style="text-align: center"><b>{{ t("price") }}</b></th>
                        <th style="text-align: center"><b>{{ t("orderCount") }}</b></th>
                        <th style="text-align: center"><b>{{ t("imageCount") }}</b></th>
                        <th style="text-align: center"><b>{{ t("sales") }}</b></th>
                        <th style="text-align: center"><b>{{ t("remark") }}</b></th>
                      </tr>
                    </thead>
                    <tbody v-if="this.loadding_report_order_summery === 'Y'">
                      <tr>
                        <td colspan="6">
                          <div class="d-flex justify-content-center">
                            <img
                              style="align-items: center; width: 60px"
                              src="../../assets/images/running_loading.svg"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody
                      v-if="
                        this.data_report_order_summery.length === 0 &&
                        this.loadding_report_order_summery === 'N'
                      "
                    >
                      <tr>
                        <td colspan="6">
                          <div class="d-flex justify-content-center">
                            {{ t("noDataFound") }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="this.data_report_order_summery.length !== 0">
                      <tr
                        v-for="(item, index) in this.data_report_order_summery"
                        :key="item"
                      >
                        <td scope="row" style="text-align: center">
                          {{ index + 1 }}
                        </td>
                        <td scope="row" style="text-align: center">
                          {{ formatAmount(item.amount) }}
                        </td>
                        <td style="text-align: center">
                          {{ item.order_count }}
                        </td>
                        <td style="text-align: center">
                          {{
                            item.is_mhao === "Y"
                              ? "∞"
                              : item.amount === this.mhao_price &&
                                item.is_mhao === "N"
                              ? "∞"
                              : item.image_length
                          }}
                        </td>

                        <td style="text-align: center">
                          {{ formatAmount(item.amount * item.order_count) }}
                        </td>
                        <td
                          scope="row"
                          style="text-align: left; font-size: xx-small"
                        >
                          {{
                            this.is_free_download_keep_contract==='Y'?
                              t("free"):item.amount === 0
                              ? t("specialConditionTag")
                              : item.amount === this.mhao_price &&
                                item.is_mhao === "Y"
                              ? t("packageUnlimited")
                              : item.amount === this.mhao_price &&
                                item.is_mhao === "N"
                              ? t("packageOverLimit")
                              : "-"
                          }}
                          
                          
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          &nbsp;
        </div>
      </div>
      <div v-if="this.is_event_permission === 'CHECKING'">
        <div class="d-flex justify-content-center">{{ t("authorizedChecking") }}</div>
      </div>
      <div v-if="this.is_event_permission === 'N'">
        <div class="d-flex justify-content-center">
          {{ t("pageNotAuthorized") }}
        </div>

        <div v-if="this.is_mhao !== 'Y' && this.loadding === 'N'">
          <div class="d-flex justify-content-center">{{ t("eventNotCorrect") }}</div>
        </div>
      </div>
    </div>
  </div>
  </div>
  <!-- this.is_event_permission {{ this.is_event_permission }}
  this.loadding:{{ this.loadding }}
  this.is_mhao:{{ this.is_mhao }} -->
</template>
<style scoped>
.order-page {
  background: radial-gradient(circle at top right, #f4f9ff 0%, #ffffff 45%);
  padding: 0.25rem 0 0.75rem;
}

.table-fit {
  width: 1px;
}

.btn-primary {
  background: linear-gradient(135deg, #33adf3 0%, #ab7dda 100%);
  border: none;
}

.section-card {
  border: 1px solid #e4edf7;
  border-radius: 0.9rem;
  box-shadow: 0 10px 24px rgba(32, 75, 140, 0.06);
}

.summary-hero-card,
.summary-stat-card {
  overflow: hidden;
}

.action-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  flex-wrap: wrap;
}

.action-btn {
  border-radius: 10px;
  padding: 0.42rem 0.95rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.note-text {
  text-align: left;
  font-size: 0.75rem;
  margin-top: 0.75rem;
  margin-bottom: 0;
  padding: 0.6rem 0.7rem;
  border-radius: 0.6rem;
  background: #f6fbff;
  border: 1px dashed #d2e6fb;
}

.note-list {
  margin: 0;
  padding-left: 1rem;
}

.data-table thead th {
  border-bottom: 1px solid #dce7f4;
  background: #f8fbff;
  color: #24426b;
  font-weight: 700;
  font-size: 0.82rem;
}

.data-table tbody td {
  vertical-align: middle;
}

@media (max-width: 768px) {
  .action-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
<script>
import orderDetail from "./orderDetail.vue";
//import OrderWelcomeCard from "./orderWelcomeCard.vue";
import VuejsPaginateNext from "../../components/Paginate.vue";
import axios from "axios";

const LANGUAGE_TEXT = {
  en: {
    orderSummary: "Order Summary",
    orders: "orders",
    imagesSold: "images sold",
    totalEarnings: "total earnings",
    teamShare: "team share",
    members: "members",
    ordersTitle: "orders",
    specialConditionOrderNote:
      "special condition is an order created by additional system such as <br />&nbsp;&nbsp;&nbsp;&nbsp; > Runner purchased package and additional photos sent to runner, or photographer uploaded to system after runner purchased package and runner requested additional photos <br />&nbsp;&nbsp;&nbsp;&nbsp; > Special order for event organizer according to agreed conditions with each organizer (if any) <br />&nbsp;&nbsp;&nbsp;&nbsp; > Used Coupon code for ordering",
    order: "ORDER",
    quantity: "QUANTITY",
    video: "VIDEO",
    amount: "AMOUNT",
    createDate: "CREATE DATE",
    payment: "PAYMENT",
    remark: "REMARK",
    free: "Free",
    specialConditionTag: "[special condition]",
    packageUnlimited: "Unlimited Package",
    packageOverLimit: "Unlimited Package",
    photographerSummary: "Photographer Summary",
    no: "No.",
    photographerId: "Photographer ID",
    name: "Name",
    uploadCount: "Upload Count",
    salesCount: "Sales Count",
    salesCountPercent: "Sales Count (%)",
    noDataFound: "No data found",
    orderSalesSummaryByImages: "Order Sales Summary by Number of Images",
    salesByImageCount: "Sales divided by number of images in order",
    specialConditionReportNote:
      "special condition is an order created by additional system such as <br />&nbsp;&nbsp;&nbsp;&nbsp; > Runner purchased package and additional photos sent to runner, or photographer uploaded to system after runner purchased package System creates order to send additional photos to runner <br />&nbsp;&nbsp;&nbsp;&nbsp; > Special order for event organizer according to agreed conditions with each organizer (if any) <br />&nbsp;&nbsp;&nbsp;&nbsp; > Used Coupon code for ordering",
    price: "Price",
    orderCount: "Order Count",
    imageCount: "Image Count",
    sales: "Sales",
    authorizedChecking: "authorized checking...",
    pageNotAuthorized: "this page is not authorized",
    eventNotCorrect: "event is not currect!",
    eventDetailError: "[EventDetail] Error occurred!",
    permissionCheckError: "Permission check error!",
    permissionCheckContactAdmin:
      "Permission check error, please contact system administrator",
    systemErrorContactAdmin:
      "Error occurred, please contact system administrator",
    loadOrderError: "Load order error!",
    reportPerformanceError: "reportPerformance error!",
    reportOrderSummaryError: "reportOrderSummery error!",
  },
  th: {
    orderSummary: "สรุปคำสั่งซื้อ",
    orders: "คำสั่งซื้อ",
    imagesSold: "จำนวนภาพที่ขาย",
    totalEarnings: "รายได้รวม",
    teamShare: "ส่วนแบ่งทีม",
    members: "ท่าน",
    ordersTitle: "คำสั่งซื้อของทีม",
    specialConditionOrderNote:
      "special condition คือออเดอร์ที่สร้างโดยระบบเพิ่มเติม อาทิเช่น <br />&nbsp;&nbsp;&nbsp;&nbsp; > นักวิ่งเหมาแล้ว และส่งรูปเพิ่มเติมให้นักวิ่ง หรือ ช่างภาพ upload เข้ามาในระบบหลังจากนักวิ่งเหมาไปแล้ว และนักวิ่งแจ้งขอรูปเพิ่มเติม <br />&nbsp;&nbsp;&nbsp;&nbsp; > ออเดอร์พิเศษให้กับผู้จัดกิจกรรม ตามเงือนไขที่ตกลงกับผู้จัดแต่ละกิจกรรม(ถ้ามี) <br />&nbsp;&nbsp;&nbsp;&nbsp; > ใช้ Coupon code ในการสั่งซื้อ",
    order: "คำสั่งซื้อ",
    quantity: "จำนวนรูป",
    video: "วีดีโอ",
    amount: "ยอดขาย",
    createDate: "วันที่สร้างออร์เดอร์",
    payment: "วันที่ชำระเงิน",
    remark: "หมายเหตุ",
    free: "Free",
    specialConditionTag: "[special condition]",
    packageUnlimited: "แพ็กเกจ เหมา",
    packageOverLimit: "เลือกรูปเกินราคาเหมา",
    photographerSummary: "สรุปข้อมูลช่างภาพ",
    no: "ลำดับ",
    photographerId: "รหัสช่างภาพ",
    name: "ชื่อ",
    uploadCount: "จำนวนที่อัปโหลด",
    salesCount: "จำนวนยอดขาย",
    salesCountPercent: "จำนวนยอดขาย(%)",
    noDataFound: "ไม่พบข้อมูล",
    orderSalesSummaryByImages: "ข้อมูลสรุปยอดขายตามจำนวนภาพของออเดอร์",
    salesByImageCount: "ยอดขายแบ่งตามจำนวนภาพภายในออเดอร์",
    specialConditionReportNote:
      "special condition คือออเดอร์ที่สร้างโดยระบบเพิ่มเติม อาทิเช่น <br />&nbsp;&nbsp;&nbsp;&nbsp; > นักวิ่งเหมาแล้ว และส่งรูปเพิ่มเติมให้นักวิ่ง หรือ ช่างภาพ upload เข้ามาในระบบหลังจากนักวิ่งเหมาไปแล้ว ระบบสร้างออเดอร์เพื่อส่งรูปเพิ่มเติมให้กับนักวิ่ง <br />&nbsp;&nbsp;&nbsp;&nbsp; > ออเดอร์พิเศษให้กับผู้จัดกิจกรรม ตามเงือนไขที่ตกลงกับผู้จัดแต่ละกิจกรรม(ถ้ามี) <br />&nbsp;&nbsp;&nbsp;&nbsp; > ใช้ Coupon code ในการสั่งซื้อ",
    price: "ราคาขาย",
    orderCount: "จำนวนออเดอร์",
    imageCount: "จำนวนรูป",
    sales: "ยอดขาย",
    authorizedChecking: "authorized checking...",
    pageNotAuthorized: "this page is not authorized",
    eventNotCorrect: "event is not currect!",
    eventDetailError: "[EventDetail]พบข้อผิดพลาด!",
    permissionCheckError: "การตรวจสอบสิทธิ์ พบข้อผิดพลาด! ",
    permissionCheckContactAdmin: "การตรวจสอบสิทธิ์ พบข้อผิดพลาด กรุณาแจ้งผู้ดูแลระบบ",
    systemErrorContactAdmin: "พบข้อผิดพลาดกรุณาติดต่อผู้ดูแลระบบ",
    loadOrderError: "Load order พบข้อผิดพลาด!",
    reportPerformanceError: "reportPerformance พบข้อผิดพลาด! ",
    reportOrderSummaryError: "reportOrderSummery พบข้อผิดพลาด! ",
  },
};

export default {
  name: "order",
  components: {
    orderDetail,
    paginate: VuejsPaginateNext,
  },
  setup() {},
  data() {
    return {
      eventDetails: {},
      orders: [],
      is_mhao: "Y",
      mhao_price: 10000,
      order_count: 0,
      page_tab: 0,
      loadding: "N",
      page: 1,
      init_page_size: 30,

      total_order: null,
      total_amt: null,
      p_share: null,
      total_image: null,
      photographer_share: null,
      number_of_photographer: null,

      loadding_order_image_by_user: "N",
      data_order_image_by_user: [],

      loadding_report_performance: "N",
      data_report_performance: [],

      loadding_report_order_summery: "N",
      data_report_order_summery: [],

      is_photographer_view_report: "N",

      is_event_permission: "CHECKING",

      vat: null,
      total_amt_vat: null,
      p_share_vat: null,
      token: localStorage.getItem("jwt"),
      is_exporting_excel: false,
      admin_user_id_apisitchu: parseInt(process.env.VUE_APP_ADMIN_USER_ID_APISITCHU),
    };
  },
  async created() {
    const res = await axios.get("/v1/events/" + this.$route.params.q);
    //console.log("res.data", JSON.stringify(res.data));
    if (res.data.status === "success") {
      this.eventDetails = res.data;
      this.eventPackage = res.data.package;

      this.mhao_price = res.data.mhao_price;
      return res.data;
    } else {
      alert(this.t("eventDetailError"));
      this.$router.push({ path: "/" });
    }
  },
  async mounted() {
    //this.user = this.user_store.user.body;
    this.user = JSON.parse(localStorage.getItem("user")) || {};

    //check permesion
    let _is_event_permission = await this.event_permission();
    //console.log("_is_event_permission:"+_is_event_permission)
    if (_is_event_permission === "Y") {
      this.loadOrderSummery();
    }
  },
  computed: {
    isEnglish() {
      return (process.env.VUE_APP_LANGUAGE || "").toUpperCase() === "EN";
    },
  },
  methods: {
    t(key) {
      const lang = this.isEnglish ? "en" : "th";
      return LANGUAGE_TEXT[lang][key] || LANGUAGE_TEXT.en[key] || key;
    },
    formatCount(value) {
      const parsed = Number(value || 0);
      return Number.isFinite(parsed) ? parsed.toLocaleString("th-TH") : "0";
    },
    formatAmount(value) {
      const parsed = Number(value || 0);
      if (!Number.isFinite(parsed)) {
        return "0.00";
      }
      return parsed.toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async exportExcelReport() {
      if (this.is_exporting_excel) {
        return;
      }

      const token = localStorage.getItem("jwt") || this.token;
      if (!token) {
        alert(this.t("permissionCheckContactAdmin"));
        return;
      }

      this.is_exporting_excel = true;
      try {
        const eventKey = this.$route.params.q;
        const response = await axios.post(
          `/v1/order/order-paid-excel-report/${eventKey}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
            responseType: "blob",
          }
        );

        const contentDisposition = response.headers["content-disposition"] || "";
        const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
        const decodedFileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1]) : null;
        const filename = decodedFileName || `order-paid-report-${eventKey}.xlsx`;

        const blob = new Blob([
          response.data,
        ], {
          type:
            response.headers["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        try {
          const errorText = await error?.response?.data?.text?.();
          const parsedError = errorText ? JSON.parse(errorText) : null;
          alert(parsedError?.message || this.t("systemErrorContactAdmin"));
        } catch (parseError) {
          alert(this.t("systemErrorContactAdmin"));
        }
      } finally {
        this.is_exporting_excel = false;
      }
    },
    async event_permission() {
      try {
        let data = {
          event_key: this.$route.params.q,
        };
        const headers = {
         'Authorization': 'Bearer ' + localStorage.getItem("jwt")
        };
        const response = await axios.post("v1/order/event-permission", data, {
          headers
        });
        //console.log(JSON.stringify(response))
        if (response.data.status === "success") {
          this.is_event_permission = response.data.body.event_permission;
          return response.data.body.event_permission;
        } else {
          alert(this.t("permissionCheckError"));
          return "N";
        }
      } catch (error) {
        alert(this.t("permissionCheckContactAdmin"));
        return "N";
      }
    },
    async loadOrderSummery() {
      try {
        this.loadding = "Y";
        this.total_order = 0;
        this.total_image = 0;
        this.total_amt_vat = 0;
        this.p_share_vat = 0;
        const headers = {
         'Authorization': 'Bearer ' + localStorage.getItem("jwt")
      };
        const response_summery = await axios.get(
          "/v1/order/order-summery/" + this.$route.params.q,
          {
            headers
          }
        );

        if (response_summery.data.is_mhao === "Y") {
          this.total_order = response_summery.data.body.total_order;
          this.total_amt = response_summery.data.body.total_amt;
          this.p_share = response_summery.data.body.p_share;
          this.total_image = response_summery.data.body.total_image;
          this.photographer_share =
            response_summery.data.body.photographer_share;
          this.number_of_photographer =
            response_summery.data.body.number_of_photographer;
          this.is_photographer_view_report =
            response_summery.data.body.is_photographer_view_report;
          this.vat = response_summery.data.body.vat;
          this.total_amt_vat = response_summery.data.body.total_amt_vat;
          this.p_share_vat = response_summery.data.body.p_share_vat;
          this.is_free_download_keep_contract = response_summery.data.is_free_download_keep_contract;
          // set for detail pagination //
          this.order_count = this.total_order;
          this.page_tab = Math.round(
            this.total_order / this.init_page_size + 0.5
          );
          //----------------//
          this.loadOrder();
        }
      } catch (error) {
        alert(this.t("systemErrorContactAdmin"), error);
        location.reload();
      }
    },
    async loadOrder() {
      this.loadding = "Y";
      let data = {
        page: 1,
        page_size: this.init_page_size,
        order_count: this.order_count,
        page_tab: this.page_tab,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "/v1/order/order-paid-pagination/" + this.$route.params.q,
        data,
        {
          headers
        }
      );
      //console.log("response"+JSON.stringify(response));
      if (response.data.status === "success") {
        this.orders = response.data.body;
        this.is_mhao = response.data.is_mhao;
        this.loadding = "N";
      } else {
        alert(this.t("loadOrderError"));
        this.loadding = "N";
      }
    },
    async clickCallback(pageNum) {
      let data = {
        page: pageNum,
        page_size: this.init_page_size,
        order_count: this.order_count,
        page_tab: this.page_tab,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "/v1/order/order-paid-pagination/" + this.$route.params.q,
        data,
        {
          headers
        }
      );
      this.orders = response.data.body;
    },
    async reportPerformance() {
      this.loadding_report_performance = "Y";
      this.data_report_performance = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/admin/dashboard-report-performance",
        data,
        {
          headers
        }
      );

      if (response.data.status === "success") {
        this.data_report_performance = response.data.body;

        this.loadding_report_performance = "N";
      } else {
        alert(this.t("reportPerformanceError"));
      }
    },
    async loadOrderImageByUser() {
      this.loadding_order_image_by_user = "Y";
      this.data_order_image_by_user = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/admin/running-order-image-by-user",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.data_order_image_by_user = response.data.body;

        this.loadding_order_image_by_user = "N";
      } else {
        alert(this.t("loadOrderError"));
      }
    },
    async reportOrderSummery() {
      this.loadding_report_order_summery = "Y";
      this.data_report_order_summery = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const response = await axios.post(
        "v1/admin/dashboard-report-order-summery",
        data
      );

      if (response.data.status === "success") {
        this.data_report_order_summery = response.data.body;

        this.loadding_report_order_summery = "N";
      } else {
        alert(this.t("reportOrderSummaryError"));
      }
    },
  },
};
</script>
